import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderAddRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-add-right"><path d="M11.25 19.25H2.75V3.75H10L12 6.75H21.25V10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18 13.75V17V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.75 17H18H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFolderAddRight;
